export const FETCH_VEHICLES_DOCUMENTS_DATA = "FETCH_VEHICLES_DOCUMENTS_DATA";
export const FETCH_VEHICLES_DOCUMENTS_SUCCESS = "FETCH_VEHICLES_DOCUMENTS_SUCCESS";
export const FETCH_VEHICLES_DOCUMENTS_FAILURE = "FETCH_VEHICLES_DOCUMENTS_FAILURE";